<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- 时间筛选 -->
            <a-col :md="4" :sm="24">
              <a-form-item label="时间类型">
                <a-select v-model="queryParam.timeType" placeholder="请选择时间类型" @change="handleTimeTypeChange" style="width: 100%">
                  <a-select-option :value="1">按日</a-select-option>
                  <a-select-option :value="2">按月</a-select-option>
                  <a-select-option :value="3">按年</a-select-option>
                  <a-select-option :value="4">自定义</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24" v-if="queryParam.timeType === 1">
              <a-form-item label="选择日期">
                <a-date-picker v-model="queryParam.date" placeholder="请选择日期" format="YYYY-MM-DD" style="width: 100%" />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24" v-if="queryParam.timeType === 2">
              <a-form-item label="选择月份">
                <a-month-picker v-model="queryParam.month" placeholder="请选择月份" format="YYYY-MM" style="width: 100%" />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24" v-if="queryParam.timeType === 3">
              <a-form-item label="选择年份">
                <a-date-picker v-model="queryParam.year" picker="year" placeholder="请选择年份" format="YYYY" style="width: 100%" />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24" v-if="queryParam.timeType === 4">
              <a-form-item label="开始时间">
                <a-date-picker v-model="queryParam.startTime" show-time placeholder="请选择开始时间" style="width: 100%" />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24" v-if="queryParam.timeType === 4">
              <a-form-item label="结束时间">
                <a-date-picker v-model="queryParam.endTime" show-time placeholder="请选择结束时间" style="width: 100%" />
              </a-form-item>
            </a-col>

            <!-- 其他筛选条件 -->
            <a-col :md="4" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入订单编号" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userMobile" placeholder="请输入用户手机号" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>

<!--            <a-col :md="4" :sm="24">-->
<!--              <a-form-item label="导购员名称">-->
<!--                <a-input v-model="queryParam.guideName" placeholder="请输入导购员名称" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->

            <a-col :md="4" :sm="24">
              <a-form-item label="订单状态">
                <a-select v-model="queryParam.orderStatus" placeholder="请选择订单状态" allow-clear style="width: 100%">
                  <a-select-option :value="2010">待付款</a-select-option>
                  <a-select-option :value="1">购买会员已完成</a-select-option>
                  <a-select-option :value="2020">待发货</a-select-option>
                  <a-select-option :value="2030">待收货</a-select-option>
                  <a-select-option :value="2040">待评价</a-select-option>
                  <a-select-option :value="2050">已完成</a-select-option>
                  <a-select-option :value="2060">已取消</a-select-option>
                  <a-select-option :value="2070">已关闭</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="对账类型">
              <a-select v-model="queryParam.reconciliationType" mode="multiple" placeholder="请选择对账类型(可多选)" allow-clear style="width: 100%">
                <a-select-option :value="1">商品订单</a-select-option>
                <a-select-option :value="2">PLUS会员购买</a-select-option>
                <a-select-option :value="3">余额充值</a-select-option>
                <a-select-option :value="4">退款冲减</a-select-option>
              </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item label="支付方式">
                <a-select v-model="queryParam.rechargeType" placeholder="请选择支付方式" allow-clear style="width: 100%">
                  <a-select-option value="1">微信</a-select-option>
                  <a-select-option value="2">支付宝</a-select-option>
                  <a-select-option value="3">余额</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

<!--            <a-col :md="4" :sm="24">-->
<!--              <a-form-item label="订单类型">-->
<!--                <a-select v-model="queryParam.orderType" placeholder="请选择订单类型" allow-clear style="width: 100%">-->
<!--                  <a-select-option :value="1">普通订单</a-select-option>-->
<!--                  <a-select-option :value="2">秒杀订单</a-select-option>-->
<!--                  <a-select-option :value="3">拼团订单</a-select-option>-->
<!--                  <a-select-option :value="4">直播订单</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->

            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
                <a-button type="success" style="margin-left: 8px" @click="handleGenerate" :loading="generating">
                  <a-icon type="sync" />生成数据
                </a-button>
                <a-button type="warning" style="margin-left: 8px" @click="handleExport" :loading="exporting" v-hasPermi="['order:reconciliation:export']">
                  <a-icon type="download" />导出
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-row type="flex" :gutter="16" style="margin-bottom: 16px; flex-wrap: nowrap;" v-if="summary">
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="订单数" :value="summary.orderCount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="商品数量" :value="summary.goodsCount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="实付金额" :precision="2" prefix="¥" :value="summary.payAmount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="余额支付" :precision="2" prefix="¥" :value="summary.balancePayAmount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="退款金额" :precision="2" prefix="¥" :value="summary.refundAmount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="总优惠金额" :precision="2" prefix="¥" :value="summary.totalDiscount || 0" />
          </a-card>
        </a-col>
        <a-col flex="1">
          <a-card size="small">
            <a-statistic title="导购员收益" :precision="2" prefix="¥" :value="summary.guideIncome || 0" />
          </a-card>
        </a-col>

      </a-row>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
        :scroll="{ x: 3000 }"
        @change="handleTableChange"
      >
        <!-- 商品信息 -->
        <span slot="goodsInfo" slot-scope="text, record">
          <div style="display: flex; align-items: center;">
            <a-avatar :src="record.goodsPicture" shape="square" :size="40" style="margin-right: 8px" />
            <div>
              <div>{{ record.goodsName }}</div>
              <div style="font-size: 12px; color: #999;">ID: {{ record.goodsId }}</div>
            </div>
          </div>
        </span>

        <!-- 价格金额 -->
        <span slot="price" slot-scope="text">
          <span style="color: #52c41a; font-weight: bold;">¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}</span>
        </span>

        <!-- 订单状态 -->
        <span slot="orderStatus" slot-scope="text">
          <a-tag color="blue">{{ text }}</a-tag>
        </span>

        <!-- 退款状态 -->
        <span slot="refundStatus" slot-scope="text, record">
          <a-tag v-if="text === 0 || !text">未退款</a-tag>
          <a-tag v-else-if="text === 5010" color="orange">待审核</a-tag>
          <a-tag v-else-if="text === 5020" color="blue">待寄回</a-tag>
          <a-tag v-else-if="text === 5030" color="cyan">买家发货</a-tag>
          <a-tag v-else-if="text === 5048" color="purple">退款处理中</a-tag>
          <a-tag v-else-if="text === 5049" color="volcano">退款失败</a-tag>
          <a-tag v-else-if="text === 5050" color="green">退款完成</a-tag>
          <a-tag v-else-if="text === 5060" color="red">卖家拒绝</a-tag>
          <a-tag v-else-if="text === 5070" color="gray">售后关闭</a-tag>
          <span v-else>-</span>
        </span>

        <!-- 对账类型 -->
        <span slot="reconciliationType" slot-scope="text">
          <a-tag :color="getReconciliationTypeColor(text)" style="border: 1px solid; background: #fff; color: #333;">{{ text }}</a-tag>
        </span>

        <!-- PLUS等级 -->
        <span slot="plusLevel" slot-scope="text">
          <a-tag v-if="plusLevelMap[text]" color="purple">{{ plusLevelMap[text] }}</a-tag>
          <span v-else-if="text || text === 0">{{ text }}</span>
          <span v-else>-</span>
        </span>

        <!-- 支付方式 -->
        <span slot="rechargeType" slot-scope="text">
          <a-tag v-if="text === '1'" color="green">微信</a-tag>
          <a-tag v-else-if="text === '2'" color="blue">支付宝</a-tag>
          <a-tag v-else-if="text === '3'" color="orange">余额</a-tag>
          <span v-else>-</span>
        </span>

        <!-- 订单类型 -->
<!--        <span slot="orderType" slot-scope="text">-->
<!--          <a-tag :color="getOrderTypeBorderColor(text)" style="border: 1px solid; background: #fff; color: #333;">{{ text }}</a-tag>-->
<!--        </span>-->

        <!-- 优惠信息 -->
        <span slot="discount" slot-scope="text">
          <span v-if="text && parseFloat(text) > 0" style="color: #ff4d4f;">-¥{{ parseFloat(text).toFixed(2) }}</span>
          <span v-else>¥0.00</span>
        </span>

        <!-- 议价调整：正=加价 负=减价 -->
        <span slot="adjust" slot-scope="text">
          <span v-if="text && parseFloat(text) > 0" style="color: #fa8c16;">+¥{{ parseFloat(text).toFixed(2) }}</span>
          <span v-else-if="text && parseFloat(text) < 0" style="color: #52c41a;">-¥{{ Math.abs(parseFloat(text)).toFixed(2) }}</span>
          <span v-else>¥0.00</span>
        </span>

        <!-- 收益 -->
        <span slot="income" slot-scope="text">
          <span style="color: #faad14; font-weight: bold;">+¥{{ text ? parseFloat(text).toFixed(2) : '0.00' }}</span>
        </span>

        <!-- 余额付款金额（纯余额支付或混合支付均展示真实余额付款金额） -->
        <span slot="balancePayAmount" slot-scope="text, record">
          <span v-if="record.balancePayAmount && parseFloat(record.balancePayAmount) > 0" style="color: #13c2c2; font-weight: bold;">¥{{ parseFloat(record.balancePayAmount).toFixed(2) }}</span>
          <span v-else>¥0.00</span>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getReconciliationList, getReconciliationSummary, generateByDay, generateByMonth, generateByYear, generateByRange, exportReconciliation } from '@/api/order/reconciliation'
import { listPlusLevel } from '@/api/retail/plus'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'
import { download } from '@/utils/request'

export default {
  name: 'OrderReconciliation',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      generating: false,
      exporting: false,
      summary: null,
      plusLevelMap: {},
      queryParam: {
        timeType: 1, // 默认按日
        date: undefined,
        month: undefined,
        year: undefined,
        startTime: undefined,
        endTime: undefined,
        orderNo: undefined,
        userMobile: undefined,
        goodsName: undefined,
        storeName: undefined,
        merchantName: undefined,
        guideName: undefined,
        orderStatus: undefined,
        orderType: undefined,
        reconciliationType: [],
        rechargeType: undefined,
        pageNo: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        { title: '订单编号', dataIndex: 'orderNo', width: 150, fixed: 'left' },
        { title: '对账类型', dataIndex: 'reconciliationTypeName', width: 120, align: 'center', scopedSlots: { customRender: 'reconciliationType' } },
        { title: '支付方式', dataIndex: 'rechargeType', width: 100, align: 'center', scopedSlots: { customRender: 'rechargeType' } },
        { title: '商品信息', dataIndex: 'goodsName', width: 250, scopedSlots: { customRender: 'goodsInfo' } },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150 },
        { title: '数量', dataIndex: 'goodsCount', width: 80, align: 'center' },
        { title: '销售价', dataIndex: 'sellPrice', width: 100, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '进货价', dataIndex: 'costPrice', width: 100, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '毛利', dataIndex: 'profit', width: 100, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '订单状态', dataIndex: 'orderStatusName', width: 100, align: 'center', scopedSlots: { customRender: 'orderStatus' } },
        { title: '退款状态', dataIndex: 'refundStatus', width: 100, align: 'center', scopedSlots: { customRender: 'refundStatus' } },
        { title: '退款金额', dataIndex: 'refundAmount', width: 120, align: 'right', scopedSlots: { customRender: 'price' } },
        // { title: '订单类型', dataIndex: 'orderTypeName', width: 100, align: 'center', scopedSlots: { customRender: 'orderType' } },
        { title: '门店', dataIndex: 'storeName', width: 120 },
        { title: '商家', dataIndex: 'merchantName', width: 120 },
        { title: '用户昵称', dataIndex: 'userName', width: 120 },
        { title: '用户手机', dataIndex: 'userMobile', width: 130 },
        // { title: '会员等级', dataIndex: 'memberLevel', width: 100 },
        { title: 'PLUS等级', dataIndex: 'plusLevel', width: 100, align: 'center', scopedSlots: { customRender: 'plusLevel' } },
        { title: '销售总价', dataIndex: 'sellPriceTotal', width: 120, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '订单金额', dataIndex: 'totalAmount', width: 120, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '运费', dataIndex: 'shippingPayAmount', width: 100, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '实付金额', dataIndex: 'payAmount', width: 120, align: 'right', scopedSlots: { customRender: 'price' } },
        { title: '余额付款金额', dataIndex: 'balancePayAmount', width: 120, align: 'right', scopedSlots: { customRender: 'balancePayAmount' } },
        { title: '秒杀减免', dataIndex: 'seckillDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '拼团减免', dataIndex: 'groupDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '直播减免', dataIndex: 'liveDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: 'PLUS减免', dataIndex: 'plusDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '优惠券', dataIndex: 'couponDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '积分抵扣', dataIndex: 'pointDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '余额抵扣', dataIndex: 'balanceDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '议价调整', dataIndex: 'adjustPrice', width: 100, align: 'right', scopedSlots: { customRender: 'adjust' } },
        { title: '总优惠', dataIndex: 'totalDiscount', width: 100, align: 'right', scopedSlots: { customRender: 'discount' } },
        { title: '直推收益', dataIndex: 'directPushIncome', width: 120, align: 'right', scopedSlots: { customRender: 'income' } },
        { title: '间推收益', dataIndex: 'indirectPushIncome', width: 120, align: 'right', scopedSlots: { customRender: 'income' } },
        { title: '导购收益', dataIndex: 'guideIncome', width: 120, align: 'right', scopedSlots: { customRender: 'income' } },
        { title: '门店收益', dataIndex: 'storeIncome', width: 120, align: 'right', scopedSlots: { customRender: 'income' } },
        // { title: '总佣金', dataIndex: 'totalCommission', width: 120, align: 'right', scopedSlots: { customRender: 'income' } },
        { title: '省份', dataIndex: 'province', width: 100 },
        { title: '城市', dataIndex: 'city', width: 100 },
        { title: '支付时间', dataIndex: 'payTime', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', width: 160 }
      ]
    }
  },
  created() {
    // 默认查询今天
    this.queryParam.date = moment()
    this.loadPlusLevelMap()
    this.getList()
    this.getSummary()
  },
  methods: {
    moment,
    loadPlusLevelMap() {
      listPlusLevel().then(response => {
        const map = {}
        ;(response.data || []).forEach(item => {
          if (item.level !== null && item.level !== undefined) {
            map[item.level] = item.levelName
          }
        })
        this.plusLevelMap = map
      }).catch(() => {
        this.plusLevelMap = {}
      })
    },
    getList() {
      this.loading = true
      const params = {
        pageNo: this.queryParam.pageNo,
        pageSize: this.queryParam.pageSize
      }

      // 时间条件处理
      if (this.queryParam.timeType === 1 && this.queryParam.date) {
        params.date = moment(this.queryParam.date).format('YYYY-MM-DD')
      } else if (this.queryParam.timeType === 2 && this.queryParam.month) {
        params.month = moment(this.queryParam.month).format('YYYY-MM')
      } else if (this.queryParam.timeType === 3 && this.queryParam.year) {
        params.year = moment(this.queryParam.year).format('YYYY')
      } else if (this.queryParam.timeType === 4) {
        if (this.queryParam.startTime) {
          params.startTime = moment(this.queryParam.startTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.queryParam.endTime) {
          params.endTime = moment(this.queryParam.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
      }

      // 其他条件
      if (this.queryParam.orderNo) {
        params.orderNo = this.queryParam.orderNo
      }
      if (this.queryParam.userMobile) {
        params.userMobile = this.queryParam.userMobile
      }
      if (this.queryParam.goodsName) {
        params.goodsName = this.queryParam.goodsName
      }
      if (this.queryParam.storeName) {
        params.storeName = this.queryParam.storeName
      }
      if (this.queryParam.merchantName) {
        params.merchantName = this.queryParam.merchantName
      }
      if (this.queryParam.guideName) {
        params.guideName = this.queryParam.guideName
      }
      if (this.queryParam.orderStatus) {
        params.orderStatus = this.queryParam.orderStatus
      }
      if (this.queryParam.orderType) {
        params.orderType = this.queryParam.orderType
      }
      if (this.queryParam.reconciliationType && this.queryParam.reconciliationType.length > 0) {
        params.reconciliationType = this.queryParam.reconciliationType
      }
      if (this.queryParam.rechargeType) {
        params.rechargeType = this.queryParam.rechargeType
      }

      getReconciliationList(params).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getSummary() {
      const params = {}

      // 时间条件处理
      if (this.queryParam.timeType === 1 && this.queryParam.date) {
        params.date = moment(this.queryParam.date).format('YYYY-MM-DD')
      } else if (this.queryParam.timeType === 2 && this.queryParam.month) {
        params.month = moment(this.queryParam.month).format('YYYY-MM')
      } else if (this.queryParam.timeType === 3 && this.queryParam.year) {
        params.year = moment(this.queryParam.year).format('YYYY')
      } else if (this.queryParam.timeType === 4) {
        if (this.queryParam.startTime) {
          params.startTime = moment(this.queryParam.startTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.queryParam.endTime) {
          params.endTime = moment(this.queryParam.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
      }

      // 其他条件
      if (this.queryParam.orderNo) params.orderNo = this.queryParam.orderNo
      if (this.queryParam.userMobile) params.userMobile = this.queryParam.userMobile
      if (this.queryParam.goodsName) params.goodsName = this.queryParam.goodsName
      if (this.queryParam.storeName) params.storeName = this.queryParam.storeName
      if (this.queryParam.merchantName) params.merchantName = this.queryParam.merchantName
      if (this.queryParam.guideName) params.guideName = this.queryParam.guideName
      if (this.queryParam.orderStatus) params.orderStatus = this.queryParam.orderStatus
      if (this.queryParam.orderType) params.orderType = this.queryParam.orderType
      if (this.queryParam.reconciliationType && this.queryParam.reconciliationType.length > 0) params.reconciliationType = this.queryParam.reconciliationType
      if (this.queryParam.rechargeType) params.rechargeType = this.queryParam.rechargeType

      getReconciliationSummary(params).then(response => {
        this.summary = response.data
      }).catch(() => {
        this.summary = null
      })
    },
    handleTimeTypeChange() {
      // 清空时间相关字段
      this.queryParam.date = undefined
      this.queryParam.month = undefined
      this.queryParam.year = undefined
      this.queryParam.startTime = undefined
      this.queryParam.endTime = undefined

      // 设置默认值
      if (this.queryParam.timeType === 1) {
        this.queryParam.date = moment()
      } else if (this.queryParam.timeType === 2) {
        this.queryParam.month = moment()
      } else if (this.queryParam.timeType === 3) {
        this.queryParam.year = moment()
      }
    },
    handleTableChange(pagination, filters, sorter) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() {
      this.queryParam.pageNo = 1
      this.getList()
      this.getSummary()
    },
    resetQuery() {
      this.queryParam = {
        timeType: 1,
        date: moment(),
        month: undefined,
        year: undefined,
        startTime: undefined,
        endTime: undefined,
        orderNo: undefined,
        userMobile: undefined,
        goodsName: undefined,
        storeName: undefined,
        merchantName: undefined,
        guideName: undefined,
        orderStatus: undefined,
        orderType: undefined,
        reconciliationType: [],
        rechargeType: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.getList()
      this.getSummary()
    },
    getOrderTypeColor(type) {
      const colorMap = {
        '普通订单': 'blue',
        '秒杀订单': 'red',
        '拼团订单': 'orange',
        '直播订单': 'purple'
      }
      return colorMap[type] || 'default'
    },
    getOrderTypeBorderColor(type) {
      const colorMap = {
        '普通订单': '#1890ff',
        '秒杀订单': '#ff4d4f',
        '拼团订单': '#fa8c16',
        '直播订单': '#722ed1'
      }
      return colorMap[type] || '#d9d9d9'
    },
    getReconciliationTypeColor(type) {
      const colorMap = {
        '商品订单': '#1890ff',
        'PLUS会员购买': '#722ed1',
        '余额充值': '#fa8c16',
        '退款冲减': '#cf1322'
      }
      return colorMap[type] || '#d9d9d9'
    },
    handleGenerate() {
      if (!this.queryParam.timeType) {
        this.$message.warning('请先选择时间类型')
        return
      }

      let generateParams = {}

      if (this.queryParam.timeType === 1) {
        if (!this.queryParam.date) {
          this.$message.warning('请选择日期')
          return
        }
        generateParams = { date: moment(this.queryParam.date).format('YYYY-MM-DD') }
        this.$confirm({
          title: '提示',
          content: '确定要生成' + generateParams.date + '的订单对账数据吗?',
          okText: '确定',
          cancelText: '取消',
          okType: 'warning',
          onOk: () => {
            this.executeGenerate(generateByDay, generateParams, generateParams.date)
          }
        })
      } else if (this.queryParam.timeType === 2) {
        if (!this.queryParam.month) {
          this.$message.warning('请选择月份')
          return
        }
        generateParams = { month: moment(this.queryParam.month).format('YYYY-MM') }
        this.$confirm({
          title: '提示',
          content: '确定要生成' + generateParams.month + '的订单对账数据吗?',
          okText: '确定',
          cancelText: '取消',
          okType: 'warning',
          onOk: () => {
            this.executeGenerate(generateByMonth, generateParams, generateParams.month)
          }
        })
      } else if (this.queryParam.timeType === 3) {
        if (!this.queryParam.year) {
          this.$message.warning('请选择年份')
          return
        }
        const yearStr = moment(this.queryParam.year).format('YYYY')
        generateParams = { year: yearStr }
        this.$confirm({
          title: '提示',
          content: '确定要生成' + yearStr + '年的订单对账数据吗?',
          okText: '确定',
          cancelText: '取消',
          okType: 'warning',
          onOk: () => {
            this.executeGenerate(generateByYear, generateParams, yearStr + '年')
          }
        })
      } else if (this.queryParam.timeType === 4) {
        if (!this.queryParam.startTime || !this.queryParam.endTime) {
          this.$message.warning('请选择开始时间和结束时间')
          return
        }
        const params = {
          startTime: moment(this.queryParam.startTime).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.queryParam.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$confirm({
          title: '提示',
          content: '确定要生成自定义时间段的订单对账数据吗?',
          okText: '确定',
          cancelText: '取消',
          okType: 'warning',
          onOk: () => {
            this.executeGenerateRange(params)
          }
        })
      }
    },
    executeGenerate(generateFn, params, timeDesc) {
      this.generating = true
      console.log('开始生成对账数据:', generateFn.name, params)
      generateFn(params).then(response => {
        console.log('生成对账数据响应:', response)
        const count = response.data || 0
        this.$message.success(`成功生成${timeDesc}的${count}条订单对账数据`)
        this.getList()
        this.getSummary()
      }).catch(error => {
        console.error('生成对账数据失败:', error)
        this.$message.error('生成失败: ' + (error.message || '未知错误'))
      }).finally(() => {
        this.generating = false
      })
    },
    executeGenerateRange(params) {
      this.generating = true
      console.log('开始生成自定义时间段对账数据:', params)
      generateByRange(params).then(response => {
        console.log('生成自定义时间段对账数据响应:', response)
        const count = response.data || 0
        this.$message.success(`成功生成自定义时间段的${count}条订单对账数据`)
        this.getList()
        this.getSummary()
      }).catch(error => {
        console.error('生成自定义时间段对账数据失败:', error)
        this.$message.error('生成失败: ' + (error.message || '未知错误'))
      }).finally(() => {
        this.generating = false
      })
    },
    handleExport() {
      this.exporting = true
      const params = {}

      // 时间条件处理
      if (this.queryParam.timeType === 1 && this.queryParam.date) {
        params.date = moment(this.queryParam.date).format('YYYY-MM-DD')
      } else if (this.queryParam.timeType === 2 && this.queryParam.month) {
        params.month = moment(this.queryParam.month).format('YYYY-MM')
      } else if (this.queryParam.timeType === 3 && this.queryParam.year) {
        params.year = moment(this.queryParam.year).format('YYYY')
      } else if (this.queryParam.timeType === 4) {
        if (this.queryParam.startTime) {
          params.startTime = moment(this.queryParam.startTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.queryParam.endTime) {
          params.endTime = moment(this.queryParam.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
      }

      // 其他条件
      if (this.queryParam.orderNo) params.orderNo = this.queryParam.orderNo
      if (this.queryParam.userMobile) params.userMobile = this.queryParam.userMobile
      if (this.queryParam.goodsName) params.goodsName = this.queryParam.goodsName
      if (this.queryParam.storeName) params.storeName = this.queryParam.storeName
      if (this.queryParam.merchantName) params.merchantName = this.queryParam.merchantName
      if (this.queryParam.guideName) params.guideName = this.queryParam.guideName
      if (this.queryParam.orderStatus) params.orderStatus = this.queryParam.orderStatus
      if (this.queryParam.orderType) params.orderType = this.queryParam.orderType
      if (this.queryParam.reconciliationType && this.queryParam.reconciliationType.length > 0) params.reconciliationType = this.queryParam.reconciliationType
      if (this.queryParam.rechargeType) params.rechargeType = this.queryParam.rechargeType

      const fileName = '订单对账数据_' + moment().format('yyyyMMddHHmmss') + '.xlsx'
      download('/api/order/reconciliation/export', params, fileName).finally(() => {
        this.exporting = false
      })
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}
</style>
